// Chat log is hidden by default. Three states:
//   - hidden:  no opacity, no interaction
//   - peek:    auto-fades in for ~5 s on a new message, then back out
//   - active:  user pressed Enter, log fully visible, input focused
export class Chat {
  private log = document.getElementById("chatLog")!;
  private input = document.getElementById("chatInput") as HTMLInputElement;
  open = false;
  private peekTimer: ReturnType<typeof setTimeout> | null = null;

  constructor(private onSend: (text: string) => void) {
    this.log.classList.add("hidden-fade");
    this.input.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        const v = this.input.value.trim();
        if (v.length) this.onSend(v);
        this.input.value = "";
        this.close();
      } else if (e.key === "Escape") {
        this.input.value = "";
        this.close();
      }
      e.stopPropagation();
    });
  }

  toggle() { this.open ? this.close() : this.show(); }

  show() {
    this.log.classList.remove("hidden-fade");
    this.log.classList.add("active");
    this.input.classList.remove("hidden");
    this.input.focus();
    this.open = true;
    this.clearPeekTimer();
  }
  close() {
    this.input.classList.add("hidden");
    this.input.blur();
    this.open = false;
    // Smoothly fade out unless a peek is currently scheduled.
    this.log.classList.remove("active");
    if (!this.peekTimer) this.log.classList.add("hidden-fade");
  }

  push(name: string, text: string, system = false) {
    const row = document.createElement("div");
    row.className = "msg" + (system ? " system" : "");
    row.innerHTML = `<span class="name">${escapeHtml(name)}</span>${escapeHtml(text)}`;
    this.log.appendChild(row);
    while (this.log.children.length > 60) this.log.removeChild(this.log.firstChild!);
    this.log.scrollTop = this.log.scrollHeight;
    if (!this.open) this.peek();
  }

  private peek() {
    this.log.classList.remove("hidden-fade");
    this.clearPeekTimer();
    this.peekTimer = setTimeout(() => {
      this.peekTimer = null;
      if (!this.open) this.log.classList.add("hidden-fade");
    }, 5000);
  }
  private clearPeekTimer() {
    if (this.peekTimer) { clearTimeout(this.peekTimer); this.peekTimer = null; }
  }
}

function escapeHtml(s: string) {
  return s.replace(/[&<>"']/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]!);
}
